import { PREFIXES_DICTIONARIES } from './Constants';
export const filterDictionary = baseDictionary => {
  return Object.keys(baseDictionary || {}).reduce((acc, curr) => {
    const group = PREFIXES_DICTIONARIES.find(val =>
      curr.startsWith(val.prefix),
    );
    if (group) {
      if (!acc[group.id]) {
        acc[group.id] = {};
      }
      const lastLabel = curr.split('.').pop();
      acc[group.id] = { ...acc[group.id], [lastLabel]: baseDictionary[curr] };
    }
    return acc;
  }, {});
};
